export default "__VITE_ASSET__CkkKr19H__"